import React from 'react'
import TopfirstIcon from "./layerTopIcon1";
import TopSecondIcon from './layertopicon2'
export const LayerTop = (props) => {
    return (
        <div className="layerTop">
            <div className="layerlabelIconWrapper">
                <div className="layerlabelIcon">
                     <div className="layerTopSvg material-icons">settings </div>
                    <span className="labelstyle"> Layers</span>
                </div>
            </div>
            <div className="layerTopRight">
                <TopfirstIcon />
                <TopSecondIcon />
            </div>
        </div>
    )
}
export default LayerTop;